import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  width: 100%;
  height: 36px;
  border-radius: 2px;
  background-color: ${props => props.theme.PRIMARY};
  border: none;
  margin-top: 60px;
  font-size: 14px;
  font-weight: bold;
  color: ${props => props.theme.WHITE};
`;

function FormSubmitButton({ id, children }) {
  return (
    <Button id={id} type="submit">
      {children}
    </Button>
  );
}

FormSubmitButton.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default FormSubmitButton;
